/* "Finns i andra varianter" på slutsålda produktsidor.
   Hämtar lagerförda syskonprodukter (samma vendor + produkttyp +
   snarlik titel) via predictive search-API:t och visar dem som
   klickbara kort. Ingen automatisk omdirigering — kunden väljer
   själv. Raden förblir dold om inga syskon hittas. */

(function () {
  if (customElements.get('soldout-variants')) return;

  const MAX_CARDS = 4;

  class SoldoutVariants extends HTMLElement {
    connectedCallback() {
      this.load().catch(() => {
        /* tyst — blocket förblir dolt vid fel */
      });
    }

    async load() {
      // Matchningslogik (delad med analysskriptet) i
      // product-soldout-matching.js — laddas före den här filen
      const matcher = window.LustlySiblingMatch;
      if (!matcher) return;

      const own = {
        id: Number(this.dataset.productId),
        vendor: this.dataset.vendor,
        // productType är tom på många produkter i butiken — isSibling
        // kräver bara matchning när huvudprodukten har typ satt
        type: this.dataset.type,
        title: (this.dataset.title || '').trim(),
      };
      if (!own.vendor || !own.title) return;

      // Sök på titelns KÄRNA (utan färg-/storleksord) så att syskon
      // med flerordsfärger ("Red Wine") också hittas
      const core = matcher.coreOf(own.title);
      if (!core) return;

      const params = new URLSearchParams({
        q: core,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'hide',
      });
      const response = await fetch(`/search/suggest.json?${params}`);
      if (!response.ok) return;
      const json = await response.json();
      const products =
        (json.resources && json.resources.results && json.resources.results.products) || [];

      const matches = products
        .filter((p) => matcher.isSibling(own, p))
        .slice(0, MAX_CARDS);

      if (!matches.length) return;

      const row = this.querySelector('[data-soldout-variants-row]');
      for (const p of matches) row.appendChild(this.buildCard(p));
      this.hidden = false;
    }

    buildCard(p) {
      const card = document.createElement('a');
      card.className = 'product-soldout__card';
      card.href = p.url;

      if (p.featured_image && p.featured_image.url) {
        const img = document.createElement('img');
        const sep = p.featured_image.url.includes('?') ? '&' : '?';
        img.src = `${p.featured_image.url}${sep}width=88`;
        img.alt = '';
        img.loading = 'lazy';
        img.className = 'product-soldout__card-image';
        card.appendChild(img);
      }

      const info = document.createElement('span');
      info.className = 'product-soldout__card-info';

      const titleEl = document.createElement('span');
      titleEl.className = 'product-soldout__card-title';
      titleEl.textContent = p.title;
      info.appendChild(titleEl);

      const price = parseFloat(p.price);
      if (!Number.isNaN(price)) {
        const priceEl = document.createElement('span');
        priceEl.className = 'product-soldout__card-price';
        priceEl.textContent = `${new Intl.NumberFormat('sv-SE', {
          maximumFractionDigits: 0,
        }).format(price)} kr`;
        info.appendChild(priceEl);
      }

      card.appendChild(info);
      return card;
    }
  }

  customElements.define('soldout-variants', SoldoutVariants);
})();
